module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pl":{"headerTooltip":"Wykres prezentuje średnią cenę w sklepach wyświetlanych w widgecie (domyślne ustawienia). Aby sprawdzić średnią cenę w pozostałych sklepach, użyj filtra Wybrane sklepy."}}')
  delete Component.options._Ctor
}
